import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';
import { fadeOutAndRemove } from '@/modules/helper';

export default class extends Controller {
  static values = { form: Boolean };

  connect() {
    this.#bindPhotos();

    if (this.formValue) this.#bindRemove();
  }

  #bindPhotos() {
    const options = {
      tClose: 'Fechar (Esc)',
      tLoading: 'Carregando imagem #%curr%...',
      type: 'image',

      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        tCounter: '%curr% de %total%',
        tNext: 'Próxima (seta direita do teclado)',
        tPrev: 'Anterior (seta esquerda do teclado)',
      },

      image: {
        tError: '<a href="%url%">A imagem #%curr%</a> não pode ser carregada.',
      },
    };

    $(this.element).magnificPopup({ ...options, delegate: '[data-gallery-link]' });
  }

  #bindRemove() {
    for (const button of this.element.querySelectorAll('[data-remove-image]')) {
      button.addEventListener('click', (event) => {
        ajax({
          done: (json) => this.#removeImage(json.id),
          method: 'DELETE',
          url: `/site/images/${event.currentTarget.dataset.imageId}`,
        });
      });
    }
  }

  #removeImage(id) {
    const item = this.element.querySelector(`[data-image-id="${id}"]`)?.parentElement;

    if (item) fadeOutAndRemove(item);
  }
}
